export default __webpack_public_path__ + "static/repairClothes-633286e72307b49a1ae8e7e63e185786.jpg";